import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  FormElement,
  INPUTGROUP_VARIANT_DANGER,
  InputGroup,
  InputText,
  ToggleButton,
} from 'mailup-web-components'

import IconFontCaseSolid from 'Components/icons/IconFontCaseSolid'

import {
  modalBulkFindReplaceChangeCallback,
  modalBulkFindReplaceFetchPreviewCallback,
  modalBulkFindReplaceToggleFieldCallback,
} from 'Pages/RecipientsList/recoil/callbacks/modalBulkFindReplace'
import {
  modalBulkFindReplaceFindTextValidState,
  modalBulkFindReplaceState,
} from 'Pages/RecipientsList/recoil/state/modalBulkFindReplace'

const InputFind: FC = () => {
  const intl = useIntl()

  const { FindText, FindCaseSensitive, previewStatus, isFindTextDirty } =
    useRecoilValue(modalBulkFindReplaceState)

  const isValid = useRecoilValue(modalBulkFindReplaceFindTextValidState)

  const change = useRecoilCallback(modalBulkFindReplaceChangeCallback, [])

  const toggleField = useRecoilCallback(
    modalBulkFindReplaceToggleFieldCallback,
    [],
  )

  const fetchPreview = useRecoilCallback(
    modalBulkFindReplaceFetchPreviewCallback,
    [],
  )

  const handleFindChange = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>): void => {
    void change({ FindText: value, isFindTextDirty: true })
  }

  const handleFindBlur = (): void => {
    void fetchPreview()
  }

  const handleToggleCS = (): void => {
    void toggleField('FindCaseSensitive')
  }

  const hasFeedback = !isValid && isFindTextDirty

  const feedback = hasFeedback
    ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
    : undefined

  const feedbackVariant = hasFeedback ? 'error' : undefined

  const inputVariant = hasFeedback ? INPUTGROUP_VARIANT_DANGER : undefined

  return (
    <FormElement feedback={feedback} feedbackVariant={feedbackVariant}>
      <InputGroup variant={inputVariant}>
        <InputText
          data-mu-test="find-replace-input-find-text"
          value={FindText}
          onChange={handleFindChange}
          onBlur={handleFindBlur}
          placeholder={intl.formatMessage({
            id: 'Load.RecipientsList.ModalBulkFindReplaceFindPlaceholder',
          })}
          disabled={previewStatus === 'fetching'}
          maxLength={200}
        />
        <ToggleButton
          selected={FindCaseSensitive}
          disabled={previewStatus === 'fetching'}
          onClick={handleToggleCS}
          data-mu-test="find-replace-case-sensitive"
          data-tip={intl.formatMessage({
            id: 'Load.RecipientsList.CaseSensitiveTooltip',
          })}
        >
          <IconFontCaseSolid height="15px" />
        </ToggleButton>
      </InputGroup>
    </FormElement>
  )
}

export default InputFind
